import { render, staticRenderFns } from "./FinanceBookkeeping.vue?vue&type=template&id=8051c0d4"
import script from "./FinanceBookkeeping.vue?vue&type=script&lang=js"
export * from "./FinanceBookkeeping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports